export default __webpack_public_path__ + "static/media/polgo-mobile-1.8e47a207.png";